/** Inline icons: no icon font to download on a weak connection. */
const base = {
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

export const SendIcon = () => (
  <svg {...base}>
    <path d="M5 12h13M13 6l6 6-6 6" />
  </svg>
);
export const StopIcon = () => (
  <svg {...base}>
    <rect x="6" y="6" width="12" height="12" rx="2" fill="currentColor" />
  </svg>
);
export const SunIcon = () => (
  <svg {...base}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </svg>
);
export const MoonIcon = () => (
  <svg {...base}>
    <path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z" />
  </svg>
);
export const AutoIcon = () => (
  <svg {...base}>
    <circle cx="12" cy="12" r="8" />
    <path d="M12 4a8 8 0 0 1 0 16z" fill="currentColor" />
  </svg>
);
export const NewIcon = () => (
  <svg {...base}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);
/** Thin line icons for the suggested questions: one look, 1.6 px strokes. */
const line = { ...base, strokeWidth: 1.6 };

export const ClockIcon = () => (
  <svg {...line}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3 2" />
  </svg>
);
export const PinIcon = () => (
  <svg {...line}>
    <path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z" />
    <circle cx="12" cy="10" r="2.3" />
  </svg>
);
/** A church front with its belfry cross */
export const ChurchIcon = () => (
  <svg {...line}>
    <path d="M12 2.5v4M10.3 4.2h3.4M7 21v-9l5-4.5 5 4.5v9M4 21h16M10 21v-4a2 2 0 0 1 4 0v4" />
  </svg>
);
/** A lit candle (cirio): what is out in the street now */
export const CandleIcon = () => (
  <svg {...line}>
    <path d="M12 3.2c1.3 1.5 1.6 2.6 1.6 3.3a1.6 1.6 0 0 1-3.2 0c0-.7.3-1.8 1.6-3.3z" />
    <path d="M9.5 10.5h5V21h-5zM7.5 21h9" />
  </svg>
);
export const CalendarIcon = () => (
  <svg {...line}>
    <rect x="4" y="5.5" width="16" height="15" rx="2" />
    <path d="M8 3.5v4M16 3.5v4M4 10h16M9 14.5h2M13 14.5h2M9 17.5h2" />
  </svg>
);
export const QuestionIcon = () => (
  <svg {...line}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M9.6 9.6a2.5 2.5 0 1 1 3.4 2.3c-.6.3-1 .8-1 1.5v.4M12 16.8v.1" />
  </svg>
);
export const ChevronIcon = () => (
  <svg {...line} width={18} height={18}>
    <path d="M9 6l6 6-6 6" />
  </svg>
);

/**
 * The cross of Cruz de IA, after the silverwork of a cruz de guía: budded ends, a
 * jewel where the arms meet and a small foot. Drawn solid so it reads at 28 px.
 */
export const CrossMark = ({ size = 28 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden fill="currentColor">
    <path d="M14.8 6.2h2.4v21.3h-2.4zM8 10.8h16v2.4H8z" />
    <circle cx="16" cy="4.4" r="2.1" />
    <circle cx="6.3" cy="12" r="2.1" />
    <circle cx="25.7" cy="12" r="2.1" />
    <path d="M16 8.9l3.1 3.1-3.1 3.1-3.1-3.1z" />
    <path d="M12.6 29.6h6.8l-1.6-2.4h-3.6z" />
  </svg>
);

/**
 * A fine gold rule with a small lozenge, like the silver filigree on a paso: used
 * sparingly, under a heading. Decorative only.
 */
export const Ornament = ({ className = '' }: { className?: string }) => (
  <div className={`flex items-center gap-2 text-gold ${className}`} aria-hidden>
    <span className="h-px w-10 bg-current opacity-70" />
    <svg width="9" height="9" viewBox="0 0 10 10" fill="currentColor">
      <path d="M5 0l5 5-5 5-5-5z" />
    </svg>
    <span className="h-px w-10 bg-current opacity-70" />
  </div>
);
